import { ChangeDetectionStrategy, Component, input } from '@angular/core';

/**
 * A labelled group of rail entries (e.g. "Administration"), set off from the main entries by a
 * hairline so staff-only destinations read as their own area.
 */
@Component({
  selector: 'esn-sidebar-section',
  templateUrl: './sidebar-section.component.html',
  styleUrl: './sidebar-section.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { role: 'group', '[attr.aria-label]': 'label()' },
})
export class SidebarSectionComponent {
  readonly label = input.required<string>();
}
